import { gql } from '@grandvisionhq/graphql';

const sunglassesFragment = gql`
  fragment SunglassesFragment on SunglassesProduct {
    name
    slug
    variants {
      prices {
        originalPrice {
          currencyCode
          amount
        }
        discountedPrice {
          price {
            currencyCode
            amount
          }
        }
      }
      media {
        images {
          url
        }
      }
    }
  }
`;
const GET_BOOK_APPOINTMENT_TRY_IN_STORE_PRODUCTS = gql`
  query GetBookAppointmentTryInStoreProducts($skus: [String!]!) {
    getProductsBySKUs(skus: $skus) {
      ... on SunglassesProduct {
        ...SunglassesFragment
      }
    }
  }
  ${sunglassesFragment}
`;

export { GET_BOOK_APPOINTMENT_TRY_IN_STORE_PRODUCTS, sunglassesFragment };
//# sourceMappingURL=get-book-appointment-try-in-store-products.js.map
